globalThis.resolveDnsFallback = async (hostname) => {
    const response = await fetchServerStatus(hostname);
    return response?.raw.srv_record ?? undefined;
};
export const isServerValid = (ip, allowLocalhost = false) => {
    const isInLocalNetwork = ip.startsWith('192.168.') ||
        ip.startsWith('10.') ||
        ip.startsWith('172.') ||
        ip.startsWith('127.') ||
        ip.startsWith('localhost') ||
        ip.startsWith(':');
    const VALID_IP_OR_DOMAIN = ip.includes('.') || ip.includes('localhost');
    return (!isInLocalNetwork || allowLocalhost) && VALID_IP_OR_DOMAIN;
};
export async function fetchServerStatus(ip, signal, versionOverride) {
    if (!isServerValid(ip))
        return;
    const response = await fetch(`https://api.mcstatus.io/v2/status/java/${ip}`, { signal });
    const data = await response.json();
    const versionClean = data.version?.name_raw.replace(/^[^\d.]+/, '');
    return {
        formattedText: data.motd?.raw ?? '',
        textNameRight: data.online ?
            `${versionOverride ?? versionClean} ${data.players?.online ?? '??'}/${data.players?.max ?? '??'}` :
            '',
        icon: data.icon,
        offline: !data.online,
        raw: data
    };
}
